module.exports = __webpack_public_path__ + "img/9788936456283.713f7ef1.jpg";